<div class="row text-left justify-content-md-center mt-5">
  <div class="col-md-6">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title" id="basic-layout-form">{{ 'account.forgotPassword.title' | translate }}</h4>
        <p class="mb-0">{{ 'account.forgotPassword.text' | translate }}</p>
      </div>
      <div class="card-body">
        <div class="px-3">
          <form class="form" #forgotPasswordForm="ngForm" (ngSubmit)="onSubmit(forgotPasswordForm)">
            <h4 class="form-section"><i class="ft-cpu"></i> {{ 'account.forgotPassword.detailsHeader' | translate }}
            </h4>
            <div class="form-group">
              <label for="Email">{{ 'account.forgotPassword.emailFieldLabel' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="ft-mail"></i>
                  </span>
                </div>
                <input required type="email" class="form-control" name="Email" id="Email" #Email="ngModel" ngModel
                       email="true" placeholder="{{'account.forgotPassword.emailFieldLabel' | translate}}"
                       autocomplete="email"
                       [(ngModel)]="forgotPassword.Email"/>
              </div>
              <small class="form-text text-muted danger" *ngIf="!Email.valid && (Email.dirty || Email.touched)">
                {{ 'account.forgotPassword.emailInformationText' | translate }}
              </small>
            </div>
            <div class="form-group text-center">
              <button type="submit" class="btn btn-primary btn-raised mr-1" [disabled]="!forgotPasswordForm.valid">
                <i class="ft-mail"></i> {{ 'buttons.sendEmailText' | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
